

<div *ngIf="potentialZonesMapSectionService.isVisible |async">
    <loading [isLoading]="this.potentialZonesMapSectionService.isLoading | async"></loading>
    <polygon-selector-with-levels
    *ngIf="!isInitializing"
        #polygonSelector
        [hierarchyLevels]="hierarchyLevels"
        [autoLoad]="true"
        [isSelectionActive]="isPolygonSelectionWithevelsActive"
        [serviceType]="serviceType"
        [useExternalLayers]="true"
        (selectionChange)="onHierarchySelectionChange($event)">
    </polygon-selector-with-levels>

    <simple-polygon-selector
    *ngIf="!isInitializing"
        #agebSelector
        [sourceName]="simpleSelectorPrefixAdd"
        [autoActivate]="false"
        [fillType]="simpleSelectorPolygonFillType"
        [cloropetConfig]="agebCloropetConfig"
        [textProperty]="'Description'"
        [useExternalLayers]="true"
        (selectionChange)="onAgebSelectionChange($event)">
    </simple-polygon-selector>

    <div class="main-zones-container">
        <div class="title-container">
            <span class="panel-title">Zonas Potenciales</span>
            <span class="panel-subtitle">(Negocios vs AGEBs)</span>
        </div>
        <div class="selected-zones">
            <div class="zone-semiCircle first-selection" [ngClass]="{'selected-zone': firstZone.isSelected, 'disabled': isLoadingAgebs}" (click)="firstZone.isSelected && resetToStart() && !isLoadingAgebs">
                {{ firstZone.name }}
            </div>
            <div class="zone-semiCircle second-selection" [ngClass]="{'selected-zone': secondZone.isSelected, 'disabled': isLoadingAgebs}" (click)="secondZone.isSelected && goBack() && !isLoadingAgebs">
                {{ secondZone.name }}
            </div>
        </div>
    </div>

    <div *ngIf="secondZone.isSelected" class="second-zones-container" cdkDrag>
        <div class="right-panel-title-container" cdkDragHandle style="cursor: move;">
            <div class="right-panel-title-button" (click)="retractMainPanel()" style="cursor: pointer;">
                <mat-icon [ngClass]="{'active': !isMainPanelRetracted}">arrow_back_ios</mat-icon>
            </div>
            <div class="right-panel-title">
                <span>Zonas Potenciales <br> (Negocios vs AGEBs)</span>
            </div>
        </div>

        <div class="right-panel-content-container" [@mostrarPanel]="this.isMainPanelRetracted ? 'retracted' : 'expanded'">
            <div class="return-button-container">
                <button class="return-button" [ngClass]="{'disabled': isLoadingAgebs}" (click)="goBack()" [disabled]="isLoadingAgebs">
                    REGRESAR A ZONAS
                </button>
            </div>

            <!-- <div class="potential-zones-reference-point">
                <div class="second-title">Punto de Referencia</div>
                <div>
                    <geocoder #potentialZonesGeocoder [layerSuffix]="'potential-zones'" [layerDisplaySuffix]="'zonas potenciales'" (pointSelected)="onReferencePointSelected($event)"></geocoder>
                </div>

                esto se puede quitar o djar
                <div class="reference-point-actions">
                    <button  class="map-selection-button" 
                        [ngClass]="{'active': isMapSelectionActive}"
                        (click)="toggleMapSelection()"
                        title="Seleccionar punto en el mapa">
                        <mat-icon>{{ isMapSelectionActive ? 'location_off' : 'location_on' }}</mat-icon>
                        <span>{{ isMapSelectionActive ? 'Cancelar selección' : 'Seleccionar en mapa' }}</span>
                    </button>
                </div>
                    
            </div> -->

            <div class="potential-zones-reference-point">
                <div class="second-title">Búsqueda de Locaciones</div>
                <div>
                    <zone-location-searcher [locationHash]="locationHash" [isSearchDisabled]="this.locationHash.size == 0"> </zone-location-searcher>
                </div>
            </div>

            <div class="ageb-categories-container">
                <div class="second-title">Filtro por tipo de zona</div>
                <div class="ageb-category-container">
                    <div class="category-row">
                        <button class="category-button" 
                            *ngFor="let category of agebCategories" 
                            [ngClass]="{'active': category.isActive}"
                            [style.border-color]="category.isActive && category.color ? category.color : (category.color || '#e5e7eb')"
                            [style.background-color]="category.isActive && category.color ? category.color : 'white'"
                            (click)="selectCategory(category)">
                            <!-- <span style="display:block">({{ category.totalLocations }})</span> -->
                            {{ category.name }}
                        </button>
                    </div>
                </div>

                <div class="second-title">Total de Agebs/Tipo de Zona/Agencia</div>
                <div class="ageb-chart-container">
                    <label *ngIf="pieChartData.datasets.length === 0" class="no-data">No hay datos disponibles</label>
                    <canvas *ngIf="pieChartData.datasets.length > 0" baseChart
                        [data]="pieChartData"
                        [type]="'pie'">
                    </canvas>
                </div>
            </div>

        </div>
    </div>

    <div *ngIf="secondZone.isSelected" cdkDrag class="ageb-table-container">
        <div class="table-header" cdkDragHandle style="cursor: move;">
            <span>AGEB SELECCIONADO / TODOS</span>
        </div>
        <div class="table-content">
            <table class="agebs-table" *ngIf="sortedFeatures && sortedFeatures.length > 0">
                <thead>
                    <tr>
                        <th *ngFor="let column of tableColumns">{{ column }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let feature of sortedFeatures" (click)="selectAgebByTable(feature)"
                        [ngClass]="{'selected-row': isAgebSelected(feature)}">
                        <td *ngFor="let column of tableColumns">{{ feature.properties?.[column] }}</td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="!agebsGeoJson || agebsGeoJson.features.length == 0" class="no-data">
                No hay AGEBs disponibles
            </div>
        </div>
    </div>
</div>
